import { putAndRedirect } from "@/api"
import arrayMutators from "final-form-arrays"
import React from "react"
import { Button, Container } from "react-bootstrap"
import { Form } from "react-final-form"
import FormFields from "./FormFields"

const InviteParent = ({ invitation, urls, grades }) => {
  const onSubmit = values => {
    putAndRedirect(urls.save, urls.index, { invite: values })
  }

  const disableAll = invitation.status !== "pending"

  return (
    <Form onSubmit={onSubmit} mutators={{ ...arrayMutators }} initialValues={invitation}>
      {({ handleSubmit, submitting }) => (
        <Container className="panel-wrapper">
          <FormFields grades={grades} disableAll={disableAll} />

          <div className="d-flex justify-content-end align-items-center">
            <a href={urls.index} className="btn btn-link btn-link-primary mr-5">
              Cancel
            </a>

            <Button variant="outline-primary" onClick={handleSubmit} disabled={submitting || disableAll}>
              Continue
            </Button>
          </div>
        </Container>
      )}
    </Form>
  )
}
export default InviteParent
